import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export default {
  namespaced: true,
  state: {
    condiciones: [],
    condicionActual: null,
    horas: [],
    horaActual: null,
    liquidaciones: [],
    liquidacionActual: null,
  },
  mutations,
  getters,
  actions,
};
